import React, { PropTypes } from 'react';
import axios from '../../../../constants/axios';
import { IndexLink, Link } from 'react-router';
import { Button } from 'react-bootstrap';

class SaleReturnInvoiceDetail extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {}
      };
   }


   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`saleReturns/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data
            });
         });
   }

   render() {
      const { invoiceDetails } = this.state;
      return (
         <div className="SaleReturnInvoiceDetail" >
            <div className="details" >
               <h1>Sale Return Invoice Detail</h1>
               <div className="row" >
                  <div className="col-md-6" >
                     <p>InvoiceId: {invoiceDetails.id}</p>
                     <p className="text-success" >Customer Name: {invoiceDetails.contact_name}</p>
                     <p>Amount: {invoiceDetails.amount}</p>
                     <p>Due: {invoiceDetails.amount_due}</p>
                     <p>Memo: {invoiceDetails.memo}</p>
                     <p className="text-danger" >Invoice Created By: {invoiceDetails.invoice_created_by}</p>
                     {invoiceDetails.amount_due !== 0 &&
                     <Link to={`/saleReturn/saleReturnPayment/${invoiceDetails.id}`} >
                        <Button block bsStyle="success" >Pay</Button>
                     </Link>
                     }
                  </div>
                  <div className="col-md-6" >
                     <address>
                        <pre>Address: {invoiceDetails.contact_address}</pre>
                        <pre>District: {invoiceDetails.district_name}</pre>
                        <pre>Thana: {invoiceDetails.thana_name}</pre>
                        <pre>Address Type: {invoiceDetails.contact_address_type_name}</pre>
                     </address>
                  </div>
               </div>
               <div >
                  <ul className="nav nav-tabs" >
                     <li>
                        <IndexLink to={`/saleReturn/saleReturnInvoiceDetail/${invoiceDetails.id}`}
                                   activeStyle={{ color: 'red' }} >Items</IndexLink>
                     </li>
                     <li>
                        <Link to={`/saleReturn/saleReturnInvoiceDetail/${invoiceDetails.id}/paymentHistory`}
                              activeStyle={{ color: 'red' }} >Payment
                           History</Link>
                     </li>
                  </ul>
               </div>
            </div>
            {this.props.children}
         </div>
      );
   }
}

SaleReturnInvoiceDetail.propTypes = {
   params: PropTypes.object,
   children: PropTypes.object
};


export default SaleReturnInvoiceDetail;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/SaleReturnInvoiceDetails/SaleReturnInvoiceDetail.js
 **/